import DBOperationsComb from "src/utils/dbOperationsComb";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

// Snapshots read by the form builder's version history dialog. The builder is
// online-only, so these read the server directly. Last 50, newest first — the
// JSON is large enough that 50 is already a lot to ship over the wire.
const COLUMNS =
  "id, entity_id, version, entity_content, created_by, created_at";
const LIMIT = 50;

/**
 * A form template's snapshots, highest version first.
 *
 * @returns {Promise<{data: Array|null, totalItems: number, error: string|null}>}
 */
async function getTemplateHistory(templateId) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.FORM_VERSION_HISTORY_TABLE,
        select: COLUMNS,
        queryParams: [
          { field: "entity_id", value: templateId },
          // form_version_history.entity_type for template snapshots
          { field: "entity_type", value: "form_template" }
        ],
        fetchDeleted: true,
        sortField: "version",
        sortOrder: -1,
        page: 0,
        rows: LIMIT
      },
      false
    );
  } catch (error) {
    Exception.catchException(error);
    return { data: null, totalItems: 0, error: error.message };
  }
}

/**
 * Snapshots of the given form pages, most recent first, across all of them.
 *
 * @param {string[]} pageIds
 * @returns {Promise<{data: Array|null, totalItems: number, error: string|null}>}
 */
async function getPageHistory(pageIds) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.FORM_VERSION_HISTORY_TABLE,
        select: COLUMNS,
        queryParams: [
          {
            field: "entity_id",
            value: pageIds,
            opType: Constants.enums.COMPARISON_TYPE.OR
          },
          // form_version_history.entity_type for page snapshots
          { field: "entity_type", value: "form_page" }
        ],
        fetchDeleted: true,
        sortField: "created_at",
        sortOrder: -1,
        page: 0,
        rows: LIMIT
      },
      false
    );
  } catch (error) {
    Exception.catchException(error);
    return { data: null, totalItems: 0, error: error.message };
  }
}

export default {
  getTemplateHistory,
  getPageHistory
};
